<template>
    <div ref="accountCell" class="draftlist-account-cell" :title="accountCellInnerText">
        <account-link :account-no="draft?.accountNo" class="text-primary">
            {{ draft?.accountNo }}
        </account-link>
        &nbsp;-&nbsp;
        <span v-if="!draft?.subAccountUuid">
            {{ accountDescription(draft?.accountNo) }}
        </span>
        <sub-account-link v-else-if="draft?.subAccountUuid" :uuid="draft?.subAccountUuid" class="text-primary">
            <i class="inline-block -mb-[1px]" :class="subAccountIcon"/>
            {{ subAccountDescription(draft?.subAccountUuid) }}
        </sub-account-link>
    </div>
</template>

<script setup lang="ts">

import {computed, ref} from 'vue'
import {CUSTOMER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'
import {findAccountByNo} from '@/bookkeeping-account/bookkeepingAccount.service'
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'
import {findSubAccountByUuid} from '@/subaccount/subAccount.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
        },
        required: true
    }
})

const accountCell = ref()
const draft = computed(() => props.params?.data)

const accountCellInnerText = computed(() => {
    if (accountCell.value) {
        return accountCell.value.innerText
    }
    return ''
})
const accountDescription = (accountNo: string) => findAccountByNo(accountNo)?.name || ''
const subAccountDescription = (subAccountUuid: string) => findSubAccountByUuid(subAccountUuid)?.name || ''

const subAccountIcon = (accountNo: string) => {
    const isCustomer = accountNo === CUSTOMER_ACCOUNT_NO
    return isCustomer ? 'i-ph-user' : 'i-ph-factory'
}

</script>

<style>
@reference "@/index.css";
@reference "tailwindcss";

.draftlist-account-cell {
    @apply truncate;
}

</style>